import { differenceInHours, format, formatDistanceToNowStrict } from 'date-fns';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { useCaseListingTemplateContext } from '../../contexts/case-listing-template';

// TODO: return actual styled components, not just text

const CreatedOn = ({ createdOn }) => {
  const { columns } = useCaseListingTemplateContext();

  const newHourOffset = columns.find(({ id }) => id === 'newHourOffset');
  const oldHourOffset = columns.find(({ id }) => id === 'oldHourOffset');

  const now = new Date();
  const createdDateTime = new Date(`${createdOn}Z`);

  const distanceString = formatDistanceToNowStrict(createdDateTime, { addSuffix: true });

  if (newHourOffset) {
    if (differenceInHours(now, createdDateTime) < newHourOffset.default) {
      return <NewTime>{distanceString}</NewTime>;
    }
  }

  if (oldHourOffset) {
    if (differenceInHours(now, createdDateTime) > oldHourOffset.default) {
      return (
        <Time>
          {format(createdDateTime, 'd LLL yyyy')}
          <br />
          <OldTime>{distanceString}</OldTime>
        </Time>
      );
    }
  }

  return <Time>{format(createdDateTime, 'd LLL yyyy')}</Time>;
};

const Time = styled.div`
  justify-self: center;
`;

const NewTime = styled(Time)`
  background-color: ${({ theme }) => theme.colors.successOne};
  border-radius: 1rem;
  color: ${({ theme }) => theme.colors.successNine};
  font-size: 0.8rem;
  font-weight: bold;
  padding: 0.5rem 1.5rem;
`;

const OldTime = styled.div`
  color: ${({ theme }) => theme.colors.dangerNine};
  font-size: 0.8rem;
  padding-top: 0.5rem;
  text-align: center;
`;

CreatedOn.propTypes = {
  createdOn: PropTypes.string.isRequired,
};

export { CreatedOn };
